import {
  FaFacebook, FaTwitter, FaInstagram, FaYoutube,
} from 'react-icons/fa';

const navLinks = [
  {
    to: 'https://www.facebook.com/',
    icon: <FaFacebook />,
  },
  {
    to: 'https://www.twitter.com/',
    icon: <FaTwitter />,
  },
  {
    to: 'https://www.instagram.com/',
    icon: <FaInstagram />,
  },
  {
    to: 'https://www.youtube.com/',
    icon: <FaYoutube />,
  },
];

export default navLinks;
